import React from "react";
import { useLingui } from "@lingui/react";
import "../App.css";

const LanguageSwitcher: React.FC = () => {
  const { i18n: linguiI18n } = useLingui();

  const changeLanguage = (locale: string) => {
    linguiI18n.activate(locale);
    document.documentElement.setAttribute("dir", locale === "he" ? "rtl" : "ltr");
  };

  return (
    <div className="language-switcher">
      <button
        onClick={() => changeLanguage("en")}
        className={`language-button ${linguiI18n.locale === "en" ? "active" : ""}`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="16"
          height="12"
          viewBox="0 0 7410 3900"
        >
          <path fill="#b22234" d="M0 0h7410v3900H0z" />
          <path d="M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0" stroke="#fff" strokeWidth="300" />
          <path fill="#3c3b6e" d="M0 0h2964v2100H0z" />
          <g fill="#fff">
            <g id="d">
              <g id="c">
                <g id="e">
                  <g id="b">
                    <path id="a" d="m247 90 70.534 217.082-184.66-134.164h228.253L176.466 307.082z" />
                    <use xlinkHref="#a" y="420" />
                    <use xlinkHref="#a" y="840" />
                    <use xlinkHref="#a" y="1260" />
                  </g>
                  <use xlinkHref="#a" y="1680" />
                </g>
                <use xlinkHref="#a" x="247" y="210" />
              </g>
              <use xlinkHref="#c" x="494" />
            </g>
            <use xlinkHref="#d" x="988" />
            <use xlinkHref="#c" x="1976" />
            <use xlinkHref="#e" x="2470" />
          </g>
        </svg>
        English
      </button>

      <button
        onClick={() => changeLanguage("he")}
        className={`language-button ${linguiI18n.locale === "he" ? "active" : ""}`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="12"
          viewBox="0 0 1100 800"
        >
          <path d="M0 0h1100v800H0Z" fill="#fff" />
          <path d="M0 75h1100v125H0ZM0 600h1100v125H0Z" fill="#0038b8" />
          <path d="M423.816 472.853h252.368L550 254.295ZM550 545.705l126.184-218.558H423.816Z" fill="none" stroke="#0038b8" strokeWidth="27.5" />
        </svg>
        עברית
      </button>
    </div>
  );
};

export default LanguageSwitcher;